import { ProduktlarmDTO } from "~app/common/models/produkt/ProduktlarmDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktDetailTexts } from "../../../produkt-detail.texts";

export class ProduktDetailUppfoljningProduktlarmValidation {
    static isInteger(input: number) {
        const asString = input.toString();
        return !ObjectUtils.isNullOrUndefined(asString) && /^\d+$/.test(asString);
    }

    static init(produktlarm: ProduktlarmDTO): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => ObjectUtils.isNullOrUndefined(newValue) ||
                    (newValue >= 0 && newValue <= 100 && ProduktDetailUppfoljningProduktlarmValidation.isInteger(newValue)),
                message: { text: ProduktDetailTexts.uppfoljningTab.validation.varningsniva },
                model: () => produktlarm.varningsniva,
                name: "varningsniva"
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) => ObjectUtils.isNullOrUndefined(newValue) ||
                    (newValue >= 0 && newValue <= 100 && ProduktDetailUppfoljningProduktlarmValidation.isInteger(newValue)),
                message: { text: ProduktDetailTexts.uppfoljningTab.validation.larmniva },
                model: () => produktlarm.larmniva,
                name: "larmniva"
            }
        ]);

        return context;
    }
}
